import React, { useCallback, useState } from 'react'

import EndCallButton from 'components/Controls/EndCallButton/EndCallButton'
import GestureControlButtons from 'components/Controls/GestureControlButtons'
import ToggleAudioButton from 'components/Controls/ToggleAudioButton/ToggleAudioButton'
import ToggleVideoButton from 'components/Controls/ToggleVideoButton/ToggleVideoButton'
import ChatMobile from 'components/Room/ChatMobile'
import ChatPreview from 'components/Room/ChatMobile/ChatModal/ChatPreview'
import useRoomState from 'hooks/useRoomState/useRoomState'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'

import * as Styles from './styles'

export default function BottomOptionsContainer({ utilsVisible }) {
    const roomState = useRoomState()
    const { isQuizMode } = useVideoContext()

    const isReconnecting = roomState === 'reconnecting'

    const [shouldShowChat, setShouldShowChat] = useState(false)
    const [areOptionsMinimized, setOptionsMinimized] = useState(true)
    const handlePreviewClick = useCallback(() => {
        setShouldShowChat(true)
    }, [])

    const toggleOptionsMinimized = () => setOptionsMinimized(s => !s)

    const showUtils = utilsVisible || isQuizMode

    const gesturesView = (
        <Styles.Wrapper isVisible={!showUtils}>
            <GestureControlButtons />
        </Styles.Wrapper>
    )

    const utilsView = (
        <Styles.Wrapper isQuizMode={isQuizMode} isVisible={showUtils}>
            <Styles.OptionsWrapper
                areOptionsMinimized={areOptionsMinimized && isQuizMode}
            >
                <Styles.UtilsContainer>
                    <ChatMobile
                        shouldShowChat={shouldShowChat}
                        setShouldShowChat={setShouldShowChat}
                    />
                </Styles.UtilsContainer>
                <Styles.UtilsContainer>
                    <ToggleAudioButton disabled={isReconnecting} />
                </Styles.UtilsContainer>
                <Styles.UtilsContainer>
                    <ToggleVideoButton disabled={isReconnecting} />
                </Styles.UtilsContainer>
                <Styles.UtilsContainer>
                    <EndCallButton />
                </Styles.UtilsContainer>
            </Styles.OptionsWrapper>
            {isQuizMode && (
                <Styles.MinimizeOptionsButton onClick={toggleOptionsMinimized}>
                    <Styles.MinimizeOptionsButtonArrow
                        open={!areOptionsMinimized}
                        src="/assets/revamp/mobile-options-toggle-arrow.svg"
                    />
                    <Styles.MinimizeOptionsButtonIcon src="/assets/revamp/mobile-options-toggle.svg" />
                </Styles.MinimizeOptionsButton>
            )}
        </Styles.Wrapper>
    )

    return (
        <>
            {utilsView}
            {gesturesView}
            <ChatPreview handleClick={handlePreviewClick} />
        </>
    )
}
